<form
  #pickerForm="ngForm"
  (ngSubmit)="pickerForm.valid ? creatNewPriceList() : setFormDirty(pickerForm.control)"
>
  <div class="select__container">
    <label for="listYear">År för prislistan att gälla</label>
    <select
      id="listYear"
      name="listYear"
      [(ngModel)]="selectedPriceListYear"
      required
    >
      <option value=""></option>
      @for (year of availableYears; track $index) {
        <option [ngValue]="year.year" [disabled]="year.disabled">
          {{ year.year }}
        </option>
      }
    </select>
  </div>

  <p>Välj vilken prislista den nya ska utgå ifrån</p>
  <div class="select__container">
    <label for="copyYear">Befintliga prislistor</label>
    <select
      id="copyYear"
      name="copyYear"
      [(ngModel)]="selectedPriceList"
      required
    >
      <option value=""></option>
      @for (list of availablePriceLists; track $index) {
        <option [ngValue]="list">{{ priceListLabel(list) }}</option>
      }
    </select>
  </div>

  <button type="submit" class="button">Skapa</button>
  <button type="button" class="link" (click)="cancel()">Avbryt</button>
</form>
